export const assignmentsListingRoutes = [
  {
    path: 'listing',
    name: 'assignments-listing',
    component: () =>
      import(/* webpackChunkName: "assignments-listing" */ './AssignmentsListing.vue')
  },
  {
    path: 'create',
    name: 'create-assignment',
    component: () =>
      import(/* webpackChunkName: "new-assignment" */ '../new-assignment/NewAssignment.vue')
  }
];
